import { useCallback, useRef, useState } from 'react';
export function useHover(_ref) {
  let {
    initialIndex,
    listLength
  } = _ref;
  const ref = useRef(null);
  const [hoveredIndex, setHoveredIndex] = useState(initialIndex);
  const hoverWithOffset = useCallback(function (offset, options) {
    if (options === void 0) {
      options = {};
    }
    const newIndex = rotateIndex(hoveredIndex, listLength, offset);
    if (options.scrollPosition && ref.current) {
      scrollToIndex(ref.current, newIndex, options.scrollPosition);
    }
    setHoveredIndex(newIndex);
  }, [listLength, hoveredIndex]);
  const hoverAtIndex = useCallback(function (index, options) {
    if (options === void 0) {
      options = {};
    }
    if (options.scrollPosition && ref.current) {
      scrollToIndex(ref.current, index, options.scrollPosition);
    }
    setHoveredIndex(index);
  }, []);
  const hoverNext = useCallback(() => hoverWithOffset(1, {
    scrollPosition: 'nearest'
  }), [hoverWithOffset]);
  const hoverPrevious = useCallback(() => hoverWithOffset(-1, {
    scrollPosition: 'nearest'
  }), [hoverWithOffset]);
  return {
    ref,
    hoveredIndex,
    hoverAtIndex,
    hoverNext,
    hoverPrevious
  };
}
const scrollToIndex = (element, index, scrollPosition) => {
  const hoveredOption = element.childNodes[index];
  if (hoveredOption instanceof HTMLElement) {
    hoveredOption.scrollIntoView({
      block: scrollPosition
    });
  }
};
function rotateIndex(currentIndex, listLength, steps) {
  let newIndex = currentIndex + steps;
  if (newIndex >= listLength) {
    newIndex = 0;
  }
  if (newIndex < 0) {
    newIndex = listLength - 1;
  }
  if (newIndex >= listLength) {
    return -1;
  } else {
    return newIndex;
  }
}
//# sourceMappingURL=use-hover.js.map